import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import MessageListItem from './MessagesListItem'


const Messages = ({ showMessageDetails, messages }) => {
  const { t } = useTranslation() 

  return (
    <div className="message-list">

      <div className="row message-list__header hide-mobile">
        <div className="col-lg-12">
          {t('Messages.list.title')}
        </div>
      </div>

      {messages.items.map(( message ) => (
        <MessageListItem 
          showMessageDetails={ showMessageDetails }
          key={message.id} 
          message={message}/>) )}
    </div>
  )
}

Messages.propTypes = {
  messages: PropTypes.object,
  showMessageDetails: PropTypes.func
}

export default Messages
